import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

export default function ModalIndex(props) {
  return (
    <Modal isOpen={props.doShow} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>{props.title}</ModalHeader>
      <ModalBody>{props.description}</ModalBody>
      <ModalFooter>
        <Button color="success" onClick={props.toggle}>{props.buttonLabel}</Button>
      </ModalFooter>
    </Modal>
  );
}
